import { render, staticRenderFns } from "./data-view-settings.vue?vue&type=template&id=766e1a58&scoped=true"
import script from "./data-view-settings.vue?vue&type=script&lang=js"
export * from "./data-view-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766e1a58",
  null
  
)

export default component.exports